export default "__VITE_ASSET__D59qrZ0n__"